/**
 * Collection-level promotion message fallback.
 *
 * On product pages, if no promotion message is already rendered (from product
 * metafields or collection URL context), this script fetches the promotion
 * message from the product's collections via the Section Rendering API and
 * injects it into the price area.
 */
(function () {
  'use strict';

  // Only run on product pages
  if (!document.querySelector('.pdp-price')) return;

  // Skip if a promotion message is already displayed
  if (document.querySelector('.price__sale-message')) return;

  // Get collection handles from the data attribute
  var container = document.querySelector('[data-product-collections]');
  if (!container) return;

  var handles;
  try {
    handles = JSON.parse(container.getAttribute('data-product-collections'));
  } catch (e) {
    return;
  }
  if (!handles || !handles.length) return;

  // Fetch each collection's promo data until we find one with a message
  function tryCollection(index) {
    if (index >= handles.length) return;

    fetch('/collections/' + handles[index] + '?sections=collection-promo-data')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var html = data['collection-promo-data'] || '';
        // The section returns JSON wrapped in a section tag; extract it
        var match = html.match(/\{[^}]*"promotion_message"[^}]*\}/);
        if (!match) {
          tryCollection(index + 1);
          return;
        }

        var promo;
        try {
          promo = JSON.parse(match[0]);
        } catch (e) {
          tryCollection(index + 1);
          return;
        }

        if (promo.promotion_message) {
          injectPromoMessage(promo.promotion_message);
        } else {
          tryCollection(index + 1);
        }
      })
      .catch(function () {
        tryCollection(index + 1);
      });
  }

  function injectPromoMessage(message) {
    var priceContainer = document.querySelector('.pdp-price .price__container');
    if (!priceContainer) return;

    var div = document.createElement('div');
    div.className = 'price__sale-message';
    div.setAttribute('role', 'note');
    div.innerHTML =
      '<div class="price__sale-message-content">' +
        '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-discount color-foreground-text" viewBox="0 0 12 12">' +
          '<path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></path>' +
        '</svg>' +
        '<span class="price__sale-message-percent">' + message + '</span>' +
      '</div>' +
      '<div class="price__sale-message-note">Applied at checkout</div>';

    priceContainer.appendChild(div);
  }

  tryCollection(0);
})();
